import axiosInstance from "../services/axiosInstance";

const logout = async () => {
  return await axiosInstance.delete(`${process.env.REACT_APP_BASE_URL}/cerrarSesion`, {
    withCredentials: true,
  });
};

export default logout;
